module.exports = __webpack_public_path__ + "img/human-resources-hierarchy-1.4cf2ec62.svg";